import i18n from '@/i18n'
import { applyTheme, applyBackground } from '@/styles/themes'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AppState {
  language: string
  theme: string
  background: string
  actor: string
  setLanguage: (language: string) => void
  setTheme: (theme: string) => void
  setBackground: (background: string) => void
  setActor: (actor: string) => void
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      language: 'sv',
      theme: 'default',
      background: 'none',
      actor: '',
      setLanguage: (language: string) => {
        set({ language })
  localStorage.setItem('klubbspel-language', language)
        // Use async/await to ensure language change is complete
        i18n.changeLanguage(language).then(() => {
          // Language changed successfully
        })
      },
      setTheme: (theme: string) => {
        set({ theme })
        localStorage.setItem('klubbspel-theme', theme)
        applyTheme(theme)
      },
      setBackground: (background: string) => {
        set({ background })
        localStorage.setItem('klubbspel-background', background)
        // Apply background asynchronously (preloads image first)
        applyBackground(background).catch(err => {
          console.error('Failed to apply background:', err)
        })
      },
      setActor: (actor: string) => set({ actor }),
    }),
    {
  name: 'klubbspel-settings',
    }
  )
)